import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/fonts/font_wza464u9yc9/iconfont.css'
import '@/assets/fonts/font_exem8tp4hr7/iconfont.css'
import '@/assets/fonts/font_7q2a6hjtzd7/iconfont.css'

// 导入 axios 配置，自动注册拦截器（必须在其他导入 axios 的组件之前）
import '@/utils/axios-config'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router)
app.use(ElementPlus, {
  locale: zhCn
})
app.mount('#app')
